import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { CommandPaletteItemType } from "@/components/CommandPalette/types";

export interface RecentItem {
  id: string;
  type: Exclude<CommandPaletteItemType, "action">;
  name: string;
  description?: string;
  route: string;
  visitedAt: number;
}

interface CommandPaletteState {
  isOpen: boolean;
  recentItems: RecentItem[];
  open: () => void;
  close: () => void;
  toggle: () => void;
  addRecentItem: (item: Omit<RecentItem, "visitedAt">) => void;
  clearRecentItems: () => void;
}

const MAX_RECENT_ITEMS = 10;

export const useCommandPaletteStore = create<CommandPaletteState>()(
  persist(
    (set, get) => ({
      isOpen: false,
      recentItems: [],

      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),
      toggle: () => set((state) => ({ isOpen: !state.isOpen })),

      addRecentItem: (item) => {
        const { recentItems } = get();

        if (
          recentItems[0]?.id === item.id &&
          recentItems[0]?.type === item.type
        ) {
          return;
        }

        const filtered = recentItems.filter(
          (r) => !(r.id === item.id && r.type === item.type)
        );

        set({
          recentItems: [{ ...item, visitedAt: Date.now() }, ...filtered].slice(
            0,
            MAX_RECENT_ITEMS
          ),
        });
      },

      clearRecentItems: () => set({ recentItems: [] }),
    }),
    {
      name: "command-palette-storage",
      version: 1,
      partialize: (state) => ({ recentItems: state.recentItems }),
    }
  )
);
